import { render, staticRenderFns } from "./SellerDropdownField.vue?vue&type=template&id=162d2d04"
import script from "./SellerDropdownField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SellerDropdownField.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162d2d04')) {
      api.createRecord('162d2d04', component.options)
    } else {
      api.reload('162d2d04', component.options)
    }
    module.hot.accept("./SellerDropdownField.vue?vue&type=template&id=162d2d04", function () {
      api.rerender('162d2d04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/SellerDropdownField.vue"
export default component.exports